module.exports = { raw: '9.5.1' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = 175
// module chunks = 0